export function applyContentLinkTargets(html, { enabled = true } = {}) {
    if (!enabled || !html || typeof html !== 'string') {
        return html ?? '';
    }

    if (typeof DOMParser === 'undefined') {
        return html;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('a[href]').forEach(anchor => {
        const href = anchor.getAttribute('href')?.trim() ?? '';

        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
            return;
        }

        if (anchor.hasAttribute('target')) {
            if (anchor.getAttribute('target')?.toLowerCase() === '_blank') {
                const relTokens = new Set(
                    (anchor.getAttribute('rel') ?? '').toLowerCase().split(/\s+/).filter(Boolean)
                );
                relTokens.add('noopener');
                relTokens.add('noreferrer');
                anchor.setAttribute('rel', [...relTokens].join(' '));
            }

            return;
        }

        anchor.setAttribute('target', '_blank');
        anchor.setAttribute('rel', 'noopener noreferrer');
    });

    return doc.body.innerHTML;
}
